import { uri } from '../../api-endpoint';
import {
  IModelAPIValidationError,
  IModelFromAPISuccessResponse
} from '../../type-conversion/model/from-api-repsonse';
import { ModelAPIRequestBodyPartial } from '../../type-conversion/model/to-api-request-body';
import { updatePartiallyTemplateFn } from '../common';

export const updateModelPartially = (token: string) => (modelId: number) =>
  updatePartiallyTemplateFn(
    token,
    uri.modelById(modelId),
    ModelAPIRequestBodyPartial,
    IModelFromAPISuccessResponse,
    IModelAPIValidationError
  );
